import React from 'react';
import { Outlet } from 'react-router-dom';
import BottomTabBar from '../shared/BottomTabBar';

const TabLayout: React.FC = () => {
  return (
    <div className="h-full flex flex-col">
      <div className="flex-1 overflow-hidden">
        <Outlet />
      </div>
      <BottomTabBar />
    </div>
  );
};

export default TabLayout;
